<template>
    <div class="[&:not(:hover)]:line-clamp-1 whitespace-pre-line max-w-lg min-w-fit">
                {{ nextStepDetails }}
        </div>
</template>

<script setup>
import { computed } from 'vue';
import { defineProps, defineEmits, ref, watch } from 'vue';

const props = defineProps([
    'nextStep' 
])
const emit = defineEmits([
    'update-next-step'
])

const nextStepDetails = computed(() => {
    return props.nextStep ? props.nextStep.task_notes : "--"
})


</script>